import Alert, {AlertProps} from '@mui/material/Alert';
import AlertTitle, {AlertTitleProps} from '@mui/material/AlertTitle';

import {styled} from '@mui/material/styles';

export const CAlert = styled(Alert)<AlertProps>(
  (/* { theme } */) => ({
  }),
);

export const CAlertTitle = styled(AlertTitle)<AlertTitleProps>(
  (/* { theme } */) => ({
  }),
);
